import { render, staticRenderFns } from "./AuthenticationForm.vue?vue&type=template&id=245f4f24&scoped=true&lang=pug&"
import script from "./AuthenticationForm.vue?vue&type=script&lang=ts&"
export * from "./AuthenticationForm.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticationForm.vue?vue&type=style&index=0&id=245f4f24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f4f24",
  null
  
)

export default component.exports